import React, { Component } from 'react';
import actions from '../actions';
import entityActions from '../../../baseApp/entities/actions';
import sharedActions from '../../../baseApp/shared/actions';
import { connect } from 'react-redux';
import BuildingsForm from './../components/BuildingsForm';
import Validators from '../../../baseApp/shared/utils/Validators';
import { I18n } from 'react-redux-i18n';
import _ from '../../../baseApp/shared/utils/ObjectUtils';
import { getInitialStateForEntityType } from "../../otherEntities/utils";
import { availableEntityTypes } from "../../otherEntities/utils";
import { entitiesAllowedParents } from './../../otherEntities/utils';
import DateTimeUtils from '../../../baseApp/shared/utils/DateTimeUtils';

class BuildingsFormContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewMode: !_.isNilOrEmpty(props.buildingId),
            editMode: false,
            createMode: _.isNilOrEmpty(props.buildingId),
            alert: {
                show: false
            },
            buildingFormData: {
                name: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                parent: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                subFormData: getInitialStateForEntityType(availableEntityTypes.building)
            }
        }
    }

    componentDidMount() {
        const { buildingId, getBuildingData, getEntityList } = this.props;
        if (buildingId) {
            getBuildingData(buildingId);
        }
        getEntityList({
            type: entitiesAllowedParents(availableEntityTypes.building)
        });
    };

    componentWillUnmount() {
        this.props.updateCustomTitle();
        this.props.updateCustomBreadcrumbs();
    }

    componentWillReceiveProps(nextProps) {
        //Handle Error, Edit and Create
        if (this.props.loadingCreateRequest && !nextProps.loadingCreateRequest) {
            if (nextProps.buildingWasCreated) {
                this.handleBuildingCreateSuccess();
            } else {
                this.handleBuildingCreateError(nextProps.error)
            }
        } else if (this.props.loadingDeleteRequest && !nextProps.loadingDeleteRequest) {
            if (nextProps.buildingWasDeleted) {
                this.handleBuildingDeleteSuccess();
            } else {
                this.handleBuildingDeleteError(nextProps.error)
            }
        } else if (this.props.loadingEditRequest && !nextProps.loadingEditRequest) {
            if (nextProps.buildingWasEdited) {
                this.handleBuildingEditSuccess();
            } else {
                this.handleBuildingEditError(nextProps.error);
            }
        } else if (this.props.loadingBuilding && !nextProps.loadingBuilding) {
            this.handleBuildingLoadingCompleted(nextProps.buildingData)
        }
    };

    handleBuildingLoadingCompleted = buildingData => {
        const {
            updateCustomTitle,
            updateCustomBreadcrumbs
        } = this.props;

        updateCustomTitle(buildingData.name);
        updateCustomBreadcrumbs([{
            link: "/buildings",
            name: I18n.t('routes.buildings')
        }, {
            link: "/buildings/" + buildingData.id,
            name: buildingData.name
        }]);

        this.setState({
            buildingFormData: {
                ...this.state.buildingFormData,
                ...Object.entries(buildingData).reduce(
                    (acc, [key, value]) => {
                        if (this.state.buildingFormData[key]) {
                            return {
                                ...acc,
                                [key]: {
                                    ...acc[key],
                                    ...this.state.buildingFormData[key],
                                    value: value
                                }
                            }
                        } else {
                            return acc;
                        }
                    }, {}),
                subFormData: getInitialStateForEntityType(buildingData.type, buildingData)
            }
        })
    };

    handleFieldChange = (id, value) => {
        this.setState({
            buildingFormData: {
                ...this.state.buildingFormData,
                [id]: {
                    ...this.state.buildingFormData[id],
                    value: value
                }
            }
        }, () => {
            if (_.has(this.state.buildingFormData[id], 'required')) {
                this.validateField(id, false);
            }
        })
    };

    handleSubFormFieldChange = (id, value) => {
        this.setState({
            buildingFormData: {
                ...this.state.buildingFormData,
                subFormData: {
                    ...this.state.buildingFormData.subFormData,
                    [id]: {
                        ...this.state.buildingFormData.subFormData[id],
                        value: value
                    }
                }
            }
        }, () => {
            if (_.has(this.state.buildingFormData.subFormData[id], 'required')) {
                this.validateField(id, true);
            }
        })
    };

    validateField = (key, subFormField) => {
        let buildingFormData;

        if (subFormField) {
            buildingFormData = { ...this.state.buildingFormData.subFormData };
        } else {
            buildingFormData = { ...this.state.buildingFormData };
        }
        let error = null;
        switch (key) {
            case "capacity":
                error = !Validators.isInteger(buildingFormData[key].value) ? I18n.t('entities.errors.invalidCapacity') : undefined;
                break;
            case "autoCheckOutDelay":
                error = !Validators.isInteger(buildingFormData[key].value) ? I18n.t('entities.errors.autoCheckOutDelay') : undefined;
                break;
            case "latitude":
                error = !Validators.isLatitude(buildingFormData[key].value) ? I18n.t('entities.errors.invalidLatitude') : undefined;
                break;
            case "longitude":
                error = !Validators.isLongitude(buildingFormData[key].value) ? I18n.t('entities.errors.invalidLongitude') : undefined;
                break;
            case "operationTimeStart":
                const {
                    value: start
                } = buildingFormData["operationTimeStart"];

                const {
                    value: end
                } = buildingFormData["operationTimeEnd"];

                if (_.isNilOrEmpty(start)) {
                    error = I18n.t('forms.errors.emptyRequiredField')
                } else {
                    const [startHours, startMinutes] = start.split(':');
                    if (!_.isNilOrEmpty(end)) {
                        const [endHours, endMinutes] = end.split(':');
                        if (DateTimeUtils
                            .getMomentForTodayWithTime(
                                parseInt(endHours),
                                parseInt(endMinutes), 0, 0
                            )
                            .isBefore(DateTimeUtils
                                .getMomentForTodayWithTime(
                                    parseInt(startHours),
                                    parseInt(startMinutes), 0, 0
                                ))
                        ) {
                            error = I18n.t('entities.errors.operationTimeStartBeforeEnd');
                            buildingFormData["operationTimeEnd"].error = undefined;
                        }
                    }
                }
                break;
            case "operationTimeEnd":
                const {
                    value: start2
                } = buildingFormData["operationTimeStart"];

                const {
                    value: end2
                } = buildingFormData["operationTimeEnd"];

                if (_.isNilOrEmpty(end2)) {
                    error = I18n.t('forms.errors.emptyRequiredField')
                } else {
                    const [endHours2, endMinutes2] = end2.split(':');
                    if (!_.isNilOrEmpty(start2)) {
                        const [startHours2, startMinutes2] = start2.split(':');
                        if (DateTimeUtils
                            .getMomentForTodayWithTime(
                                parseInt(endHours2),
                                parseInt(endMinutes2), 0, 0
                            )
                            .isBefore(DateTimeUtils
                                .getMomentForTodayWithTime(
                                    parseInt(startHours2),
                                    parseInt(startMinutes2), 0, 0
                                ))
                        ) {
                            error = I18n.t('entities.errors.operationTimeEndAfterStart');
                            buildingFormData["operationTimeStart"].error = undefined;
                        }
                    }
                }
                break;
            default:
                if (!_.isNilOrEmpty(buildingFormData[key].error) &&
                    buildingFormData[key].required &&
                    !_.isNilOrEmpty(buildingFormData[key].value)) {
                    error = undefined;
                } else if (buildingFormData[key].required &&
                    _.isNilOrEmpty(buildingFormData[key].value)) {
                    error = I18n.t('forms.errors.emptyRequiredField')
                }
                break;
        }
        if (error !== buildingFormData[key].error) {
            buildingFormData[key].error = error;
            let fullDataForm;
            if (subFormField) {
                fullDataForm = { ...this.state.buildingFormData };
                fullDataForm.subFormData = buildingFormData;
            } else {
                fullDataForm = buildingFormData;
            }
            this.setState({
                fullDataForm,
            });
        }
    };

    handleOnFieldBlur = (key) => {
        this.validateField(key)
    };

    handleSubmitClick = () => {
        let { editMode, buildingFormData } = this.state;
        const { buildingId, editBuilding, createBuilding } = this.props;
        let formHasErrors = false;
        const conditionalFields = ["domain", "enableNotification", "autoCheckOutDelay", "operationTimeStart", "operationTimeEnd"];

        _.forOwn(buildingFormData, (field, key) => {
            if (key === 'subFormData') {
                _.forOwn(field, (subFormField, fieldKey) => {
                    if (subFormField.required  && _.isNilOrEmpty(subFormField.value) && conditionalFields.includes(fieldKey)) {
                        if (buildingFormData.subFormData.hasCheckInConfiguration.value){
                            subFormField.error = I18n.t('forms.errors.emptyRequiredField');
                            formHasErrors = true;
                        }
                    } else if (subFormField.required && _.isNilOrEmpty(subFormField.value)) {
                        subFormField.error = I18n.t('forms.errors.emptyRequiredField');
                        formHasErrors = true;
                    } else if (!_.isNilOrEmpty(subFormField.error)) {
                        formHasErrors = true;
                    } else {
                        subFormField.error = undefined;
                    }
                });
            } else {
                if ((field.required && _.isNilOrEmpty(field.value))) {
                    field.error = I18n.t('forms.errors.emptyRequiredField');
                    formHasErrors = true;
                } else if (!_.isNilOrEmpty(field.error)) {
                    formHasErrors = true;
                } else {
                    field.error = undefined;
                }
            }
        });

        if (!formHasErrors) {
            const formDataToBeSubmitted = Object.entries(buildingFormData).reduce((acc, [key, formField]) => {
                if (key === 'subFormData') {
                    const subFormData = Object.entries(formField).reduce((subFormAcc, [subFormKey, subFormField]) => {
                        return {
                            ...subFormAcc,
                            [subFormKey]: subFormField.value
                        }
                    }, {});
                    return {
                        ...acc,
                        ...subFormData
                    }
                }
                return {
                    ...acc,
                    [key]: formField.value
                }
            }, {});

            const buildingName = formDataToBeSubmitted.name;
            if (editMode) {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('buildings.alerts.edit.title'),
                        html: I18n.t('buildings.alerts.edit.text', { building: buildingName }),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            editBuilding(buildingId, formDataToBeSubmitted)
                        }
                    }
                })
            } else {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('buildings.alerts.create.title'),
                        html: I18n.t('buildings.alerts.create.text', { building: buildingName }),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            createBuilding(formDataToBeSubmitted)
                        }
                    }
                })
            }
        } else {
            this.setState({
                buildingFormData,
            });
        }
    };

    handleEditClick = () => {
        const { editMode, buildingFormData } = this.state;
        const { buildingData } = this.props;

        if (editMode) {
            this.setState({
                editMode: false,
                viewMode: true,
                buildingFormData: {
                    ...Object.entries(buildingFormData).reduce((acc, [key, formField]) => {
                        if (buildingFormData[key]) {
                            return {
                                ...acc,
                                [key]: {
                                    ...acc[key],
                                    ...this.state.buildingFormData[key],
                                    value: buildingData[key],
                                    error: undefined
                                }
                            }
                        } else {
                            return acc;
                        }
                    }, {}),
                    subFormData: getInitialStateForEntityType(buildingData.type, buildingData)
                }
            })
        } else {
            this.setState({
                viewMode: false,
                editMode: true
            })
        }
    };

    hideAlert = () => {
        this.setState({
            alert: {
                show: false
            }
        })
    };

    handleBackClick = () => {
        this.hideAlert();
        this.props.resetBuildingsForm();
        this.props.history.push({
            pathname: '/buildings',
            state: { 
                searchFieldsData : this.props.location.state?.searchFieldsData, 
                universalSearchField :  this.props.location.state?.universalSearchField
            }
          })
    };

    handleDeleteClick = () => {
        const { buildingId, deleteBuilding } = this.props;
        const {
            buildingFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: "warning",
                title: I18n.t('buildings.alerts.delete.title'),
                html: I18n.t('buildings.alerts.delete.text', { building: name }),
                confirmButtonText: I18n.t('forms.delete'),
                cancelButtonText: I18n.t('forms.cancel'),
                onCancel: this.hideAlert,
                onConfirm: () => {
                    deleteBuilding(buildingId)
                }
            }
        })
    };

    handleBuildingDeleteSuccess = () => {
        const {
            buildingFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('buildings.alerts.delete.success.title'),
                html: I18n.t('buildings.alerts.delete.success.text', { building: name }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleBuildingDeleteError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('buildings.alerts.delete.error.title'),
                html: I18n.t('buildings.alerts.delete.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleBuildingCreateSuccess = () => {
        const {
            buildingFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('buildings.alerts.create.success.title'),
                html: I18n.t('buildings.alerts.create.success.text', { building: name }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleBuildingCreateError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('buildings.alerts.create.error.title'),
                html: I18n.t('buildings.alerts.create.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleBuildingEditSuccess = () => {
        const {
            buildingFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('buildings.alerts.edit.success.title'),
                html: I18n.t('buildings.alerts.edit.success.text', { building: name }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleBuildingEditError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('buildings.alerts.edit.error.title'),
                html: I18n.t('buildings.alerts.edit.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    render() {
        const { createMode, editMode, viewMode, buildingFormData, alert } = this.state;
        const { entityList, loadingDeleteRequest, loadingCreateRequest, loadingEditRequest } = this.props;

        return <BuildingsForm
            editMode={editMode}
            createMode={createMode}
            viewMode={viewMode}
            alert={{
                ...alert,
                loading: loadingDeleteRequest || loadingCreateRequest || loadingEditRequest
            }}
            buildingFormData={buildingFormData}
            entityList={entityList}

            handleSubFormFieldChange={this.handleSubFormFieldChange}
            handleFieldChange={this.handleFieldChange}
            handleOnFieldBlur={this.handleOnFieldBlur}
            handleSubmitClick={this.handleSubmitClick}
            handleEditClick={this.handleEditClick}
            handleDeleteClick={this.handleDeleteClick}
            handleBackClick={this.handleBackClick}
        />
    }
}

const mapStateToProps = ({ buildingsReducer, entitiesReducer }) => {
    return {
        entityList: entitiesReducer.entityList,

        buildingData: buildingsReducer.buildingData,
        loadingBuilding: buildingsReducer.loading,
        loadingEntityList: entitiesReducer.loadingListRequest,
        error: buildingsReducer.error,

        loadingDeleteRequest: buildingsReducer.loadingDeleteRequest,
        buildingWasDeleted: buildingsReducer.buildingWasDeleted,

        loadingCreateRequest: buildingsReducer.loadingCreateRequest,
        buildingWasCreated: buildingsReducer.buildingWasCreated,

        loadingEditRequest: buildingsReducer.loadingEditRequest,
        buildingWasEdited: buildingsReducer.buildingWasEdited
    };
};

const mapDispatchToProps = {
    getBuildingData: actions.getBuildingData,
    createBuilding: actions.createBuilding,
    editBuilding: actions.editBuilding,
    deleteBuilding: actions.deleteBuilding,
    resetBuildingsForm: actions.resetBuildingsForm,
    getEntityList: entityActions.getEntityList,

    updateCustomTitle: sharedActions.updateCustomTitle,
    updateCustomBreadcrumbs: sharedActions.updateCustomBreadcrumbs
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BuildingsFormContainer);